import React from 'react';
import type { SectionProps } from './types';

export const OverlaySettings: React.FC<SectionProps> = ({ data, setFormData }) => (
  <div>
    <label className="flex items-center space-x-2 mb-2">
      <input
        type="checkbox"
        checked={data.backgroundImage?.overlay?.enabled || false}
        onChange={e =>
          setFormData({
            ...data,
            backgroundImage: {
              ...data.backgroundImage!,
              overlay: {
                ...data.backgroundImage?.overlay,
                enabled: e.target.checked,
                color: data.backgroundImage?.overlay?.color || '#000000',
                opacity: data.backgroundImage?.overlay?.opacity || 0.5,
              },
            },
          })
        }
        className="w-4 h-4 text-primary-600 border-gray-300 rounded-md focus:ring-primary-500"
      />
      <span className="text-sm text-gray-700">Enable Overlay</span>
    </label>
    {data.backgroundImage?.overlay?.enabled && (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2 pl-4">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Overlay Color</label>
          <input
            type="color"
            value={data.backgroundImage?.overlay?.color || '#000000'}
            onChange={e =>
              setFormData({
                ...data,
                backgroundImage: {
                  ...data.backgroundImage!,
                  overlay: {
                    enabled: data.backgroundImage?.overlay?.enabled ?? false,
                    color: e.target.value,
                    opacity: data.backgroundImage?.overlay?.opacity ?? 0.5,
                  },
                },
              })
            }
            className="w-full h-10 border border-gray-300 rounded-md"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            Opacity: {((data.backgroundImage?.overlay?.opacity || 0.5) * 100).toFixed(0)}%
          </label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.1"
            value={data.backgroundImage?.overlay?.opacity || 0.5}
            onChange={e =>
              setFormData({
                ...data,
                backgroundImage: {
                  ...data.backgroundImage!,
                  overlay: {
                    enabled: data.backgroundImage?.overlay?.enabled ?? false,
                    color: data.backgroundImage?.overlay?.color ?? '#000000',
                    opacity: parseFloat(e.target.value),
                  },
                },
              })
            }
            className="w-full"
          />
        </div>
      </div>
    )}
  </div>
);
